/* Odyssey District — white edition
   Two jobs: the product form (colour → gallery + variant) and the cart drawer. */
(function () {
  'use strict';
  var OD = window.OD || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function money(cents) {
    var fmt = OD.moneyFormat || '${{amount}}';
    var n = (cents / 100);
    var amount = n.toFixed(2);
    var noDec = Math.round(n).toString();
    return fmt
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDec)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/<[^>]+>/g, '');
  }

  /* ---------------- Cart drawer ---------------- */
  var drawer = $('#cartDrawer'), veil = $('#cartVeil'), body = $('#cartBody'), foot = $('#cartFoot');
  var counts = [$('#cartCount'), $('#drawerCount')];

  function setCount(n) {
    counts.forEach(function (el) { if (el) el.textContent = n; });
  }

  function render(cart) {
    setCount(cart.item_count);
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<p class="drawer-empty">Your cart is empty.</p>';
      foot.hidden = true;
      return;
    }
    body.innerHTML = cart.items.map(function (it, i) {
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_300x$1$2') : '';
      return '<div class="line" data-line="' + (i + 1) + '">' +
        '<a class="line-img" href="' + it.url + '">' + (img ? '<img src="' + img + '" alt="">' : '') + '</a>' +
        '<div class="line-txt">' +
          '<a class="line-title" href="' + it.url + '">' + it.product_title + '</a>' +
          '<span class="line-meta">' + (it.variant_title || '') + '</span>' +
          '<div class="line-bot">' +
            '<div class="qty">' +
              '<button type="button" data-q="' + (it.quantity - 1) + '" aria-label="Decrease">−</button>' +
              '<span>' + it.quantity + '</span>' +
              '<button type="button" data-q="' + (it.quantity + 1) + '" aria-label="Increase">+</button>' +
            '</div>' +
            '<span class="line-price">' + money(it.final_line_price) + '</span>' +
          '</div>' +
          '<button type="button" class="line-remove" data-q="0">Remove</button>' +
        '</div>' +
      '</div>';
    }).join('');
    $('#cartSubtotal').textContent = money(cart.total_price);
    foot.hidden = false;
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }
  function change(line, q) {
    return fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: q })
    }).then(function (r) { return r.json(); });
  }

  var opener = $('#cartOpen');
  function openDrawer() {
    if (!drawer) return;
    veil.hidden = false;
    requestAnimationFrame(function () { veil.classList.add('on'); drawer.classList.add('on'); });
    drawer.setAttribute('aria-hidden', 'false');
    if (opener) opener.setAttribute('aria-expanded', 'true');
    document.body.classList.add('drawer-lock');
    fetchCart().then(render);
  }
  function closeDrawer() {
    if (!drawer) return;
    veil.classList.remove('on'); drawer.classList.remove('on');
    drawer.setAttribute('aria-hidden', 'true');
    if (opener) opener.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('drawer-lock');
    setTimeout(function () { veil.hidden = true; }, 320);
  }
  if (opener) opener.addEventListener('click', openDrawer);
  var closer = $('#cartClose');
  if (closer) closer.addEventListener('click', closeDrawer);
  if (veil) veil.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  if (body) body.addEventListener('click', function (e) {
    var b = e.target.closest('[data-q]');
    if (!b) return;
    var line = +b.closest('.line').getAttribute('data-line');
    b.disabled = true;
    change(line, +b.getAttribute('data-q')).then(render);
  });

  /* ---------------- Product form ---------------- */
  var pdp = $('#pdp');
  if (pdp) {
    var variants = [];
    try { variants = JSON.parse($('#pdpVariants').textContent); } catch (err) { variants = []; }
    var cPos = +pdp.getAttribute('data-colour-pos') - 1;   // index into variant.options
    var sPos = +pdp.getAttribute('data-size-pos') - 1;
    var colour = pdp.getAttribute('data-start-colour') || null;
    var size = null;
    var idInput = $('#variantId'), addBtn = $('#addBtn'), msg = $('#pdpMsg'), price = $('#price');
    /* Pre-order products carry their own button label. */
    var ADD = (addBtn && addBtn.getAttribute('data-add-label')) || 'Add to cart';
    var colourVal = $('#colourVal'), sizeVal = $('#sizeVal');

    function find(c, s) {
      for (var i = 0; i < variants.length; i++) {
        var o = variants[i].options;
        if ((cPos < 0 || o[cPos] === c) && (sPos < 0 || o[sPos] === s)) return variants[i];
      }
      return null;
    }
    function availableFor(c, s) {
      var v = find(c, s);
      return v ? v.available : false;
    }

    function paint() {
      // colour buttons
      $$('[data-colour]', pdp).forEach(function (b) {
        if (b.classList.contains('way-set')) return;
        b.setAttribute('aria-pressed', b.getAttribute('data-colour') === colour ? 'true' : 'false');
      });
      // gallery
      $$('.way-set', pdp).forEach(function (g) {
        g.classList.toggle('on', g.getAttribute('data-colour') === colour || (!colour && g.classList.contains('on')));
      });
      // size buttons: strike sold-out sizes for this colour
      $$('[data-size]', pdp).forEach(function (b) {
        var s = b.getAttribute('data-size');
        b.classList.toggle('soldout', !availableFor(colour, s));
        b.setAttribute('aria-pressed', s === size ? 'true' : 'false');
      });
      if (colourVal && colour) colourVal.textContent = colour;
      if (sizeVal) sizeVal.textContent = size || 'Select';

      var v = (sPos < 0 || size) ? find(colour, size) : null;
      if (v) {
        idInput.value = v.id;
        price.textContent = money(v.price);
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? ADD : 'Sold out';
      } else {
        idInput.value = '';
        addBtn.disabled = false;
        addBtn.textContent = ADD;
      }
      if (msg) msg.textContent = '';
    }

    pdp.addEventListener('click', function (e) {
      var cb = e.target.closest('button[data-colour]');
      if (cb) { colour = cb.getAttribute('data-colour'); paint(); return; }
      var sb = e.target.closest('button[data-size]');
      if (sb) { size = sb.getAttribute('data-size'); paint(); }
    });

    $('#pdpForm').addEventListener('submit', function (e) {
      e.preventDefault();
      if (sPos >= 0 && !size) { msg.textContent = 'Select a size'; return; }
      if (!idInput.value) { msg.textContent = 'Unavailable'; return; }
      addBtn.disabled = true; addBtn.textContent = 'Adding';
      fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: +idInput.value, quantity: 1 }] })
      }).then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status && res.status >= 400) { throw new Error(res.description || 'Could not add'); }
          addBtn.textContent = 'Added';
          setTimeout(function () { paint(); }, 1200);
          openDrawer();
        })
        .catch(function (err) { addBtn.disabled = false; addBtn.textContent = ADD; msg.textContent = err.message; });
    });

    paint();
  }
}());

/* Product-card image strip: dots follow the scroll position; arrows page on desktop. */
(function () {
  document.querySelectorAll('.card-media').forEach(function (m) {
    var t = m.querySelector('.card-track');
    var dots = m.querySelectorAll('.card-dots i');
    if (!t || !dots.length) return;
    var upd = function () {
      var i = Math.round(t.scrollLeft / Math.max(1, t.clientWidth));
      dots.forEach(function (d, k) { d.classList.toggle('on', k === i); });
    };
    t.addEventListener('scroll', function () { window.requestAnimationFrame(upd); }, { passive: true });
    m.querySelectorAll('.card-arr').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var dir = b.classList.contains('next') ? 1 : -1;
        var n = dots.length, i = Math.round(t.scrollLeft / Math.max(1, t.clientWidth));
        var to = (i + dir + n) % n;
        t.scrollTo({ left: to * t.clientWidth, behavior: 'smooth' });
      });
    });
  });
}());

